export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12873.afa82f84.jpg";